import(/* webpackMode: "eager" */ "/app/app/[lng]/components/AddCartButton.tsx");
;
import(/* webpackMode: "eager" */ "/app/app/[lng]/components/CurrencyPrice.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/[lng]/components/Dropdown.tsx");
;
import(/* webpackMode: "eager" */ "/app/app/[lng]/components/ErrorMessage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/[lng]/components/GridListButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/[lng]/components/Pagination.tsx");
;
import(/* webpackMode: "eager" */ "/app/app/[lng]/components/WishButton.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/app/public/icons/multiDiscountCover-mobile.svg");
;
import(/* webpackMode: "eager" */ "/app/public/icons/multiDiscountCover.svg");
;
import(/* webpackMode: "eager" */ "/app/public/icons/rightArrow.svg");
;
import(/* webpackMode: "eager" */ "/app/public/icons/sideNO.1.svg");
;
import(/* webpackMode: "eager" */ "/app/public/icons/sideNO.2.svg");
;
import(/* webpackMode: "eager" */ "/app/public/icons/sideNO.3.svg");
;
import(/* webpackMode: "eager" */ "/app/public/icons/sideNO.4.svg");
;
import(/* webpackMode: "eager" */ "/app/public/icons/sideNO.5.svg");
;
import(/* webpackMode: "eager" */ "/app/public/icons/singleDiscountCover-mobile.svg");
;
import(/* webpackMode: "eager" */ "/app/public/icons/singleDiscountCover.svg");
